export default "__VITE_ASSET__4720890b__"